export default "__VITE_ASSET__Bo5nx9tS__"